
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Award, Star, TrendingUp, Zap } from 'lucide-react';

interface PremiumConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  hasVouchers: boolean;
}

const PremiumConfirmationDialog = ({
  isOpen,
  onClose,
  onConfirm,
  hasVouchers
}: PremiumConfirmationDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center">
            <Award className="h-5 w-5 text-yellow-500 mr-2" />
            Konfirmo Përmirësimin Premium
          </DialogTitle>
          <DialogDescription>
            Përmirësoni shpalljen tuaj për 28 ditë për të përfituar nga veçoritë premium.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <h3 className="font-medium mb-3">Përfitimet e statusit Premium:</h3>
          <ul className="space-y-2">
            <li className="flex items-start">
              <TrendingUp className="h-5 w-5 text-brand-500 mr-2 mt-0.5" />
              <span>Dukshmëri më e lartë në rezultatet e kërkimit</span>
            </li>
            <li className="flex items-start">
              <Star className="h-5 w-5 text-yellow-500 mr-2 mt-0.5" />
              <span>Shfaqje e veçantë në listën e shpalljeve</span>
            </li>
            <li className="flex items-start">
              <Award className="h-5 w-5 text-purple-500 mr-2 mt-0.5" />
              <span>Badge profesionale që tërheq vëmendjen e blerësve</span>
            </li>
            <li className="flex items-start">
              <Zap className="h-5 w-5 text-blue-500 mr-2 mt-0.5" />
              <span>Mundësi më të mëdha për shitje të shpejta</span>
            </li>
          </ul>

          {hasVouchers && (
            <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded">
              <p className="text-green-700 text-sm">
                Ju keni kuponë premium falas në dispozicion. Nuk do të ketë pagesë për këtë përmirësim.
              </p>
            </div>
          )}
        </div>

        <DialogFooter className="sm:justify-between">
          <Button variant="outline" onClick={onClose}>
            Anulo
          </Button>
          <Button onClick={onConfirm} className="bg-yellow-500 hover:bg-yellow-600">
            Bëje Premium
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PremiumConfirmationDialog;
